import { number } from './dashboardReports.mjs';
export const SEARCH_METRICS = [
  { key: 'combined', label: 'Clicks + impressions', primary: 'clicks', secondary: 'impressions' },
  { key: 'clicks', label: 'Clicks' }, { key: 'impressions', label: 'Impressions' },
  { key: 'ctr', label: 'CTR', suffix: '%' }, { key: 'position', label: 'Position' },
];
export const ANALYTICS_METRICS = [
  { key: 'combined', label: 'Users + sessions', primary: 'users', secondary: 'sessions' },
  { key: 'sessions', label: 'Sessions' },
  { key: 'engaged_sessions', label: 'Engaged sessions', optional: true },
  { key: 'engagement_rate', label: 'Engagement rate', optional: true, suffix: '%' },
  { key: 'key_events', label: 'Key events', optional: true },
];
export function searchTrendRows(rows = []) {
  return rows.map(row => ({ ...row, ctr: number(row.ctr) ?? (number(row.clicks) !== null && number(row.impressions) !== null && row.impressions > 0 ? row.clicks / row.impressions * 100 : null) }));
}
export function trendAvailable(rows, metric, optionalAvailable) {
  if (metric.optional && !optionalAvailable) return false;
  return rows.some(row => number(row[metric.primary || metric.key]) !== null || (metric.secondary && number(row[metric.secondary]) !== null));
}
